<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <camera ref="camera" @getImgInfo="getImgInfo" />
    <camera2 ref="camera2" @getImgInfo="getImgInfo" />
    <div>
      <!-- 身份证 -->
      <div class="color-f-bg">
        <div class="say-color page-padding-l-r padding-t-10 padding-b-10 title-5">请拍摄本人的身份证证件</div>
        <div class="flex say-color title-5">
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('renXiang')">
              <img :src="renXiang.base64" class="idCardStyle" v-if="renXiang.webUrl" />
              <svg-icon v-else icon-class="authenticate-headshot" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('guoHui')">
              <img :src="guoHui.base64" class="idCardStyle" v-if="guoHui.webUrl" />
              <svg-icon v-else icon-class="authenticate-emblem" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
        <div class="page-padding-l-r padding-t-10">
          <mt-field label="商户姓名" placeholder="请输入商户姓名" v-if="renXiang.webUrl"
            v-model.trim="formData.idCardName"></mt-field>
          <mt-field label="法人身份证" placeholder="请输入法人身份证" v-if="renXiang.webUrl" v-model.trim="formData.idCardNum"
            disabled></mt-field>
          <mt-field label="有效期" placeholder="请输入有效期" v-if="guoHui.webUrl" v-model.trim="formData.dateOf"
            disabled></mt-field>
        </div>
      </div>
      <!-- 活体 -->
      <div v-if="btnStatus != 1" class="page-padding-l-r padding-t-10 padding-b-10 margin-t-10 flex-s color-f-bg">
        <div style="width: 105px">人脸识别</div>
        <div @click="renLianInfo()">
          <img :src="renLian.base64" class="faceStyle" v-if="renLian.base64" />
          <svg-icon icon-class="camera_face" class-name="faceStyle" v-else></svg-icon>
        </div>
      </div>
      <!-- 提示1 -->
      <div class="flex page-padding-l-r padding-t-10 padding-b-10 say-color title-6"
        v-if="(renXiang.webUrl || guoHui.webUrl) && btnStatus != 3">
        <div class="flex-1">
          <div class="say-color" v-if="btnStatus == 1 || (btnStatus == 2 && renLian.webUrl)">
            如信息有误，请重新拍照
          </div>
          <div class="say-color" v-else>
            {{ renLian.photoTips }}
          </div>
        </div>
        <div>
          <div class="theme-color" bindtap="resetCamera" v-if="btnStatus == 1 || (btnStatus == 2 && renLian.webUrl)"
            @click="resetCameraInfo('renXiang'), resetCameraInfo('guoHui'), resetCameraInfo('renLian')">{{ btnStatus ==
              1 ? "重新拍照" : "重新认证" }}</div>
        </div>
      </div>
      <!-- 提示2 -->
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6" v-if="btnStatus == 3">
        如遇活体检测失败，可以选择
        <span class="theme-color" @click="resetCameraInfo('renLian', 3)">重新识别</span>或
        <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large" v-if="renXiang.webUrl && guoHui.webUrl"
          :disabled="btnStatus >= 2 && !renLian.webUrl" @click="submitData">{{ btnName }}</mt-button>
      </div>
    </div>
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_FACE_PHOTO_TIPS */
/* global wx */

import camera from '@/components/camera.vue';
import camera2 from '@/components/camera2.vue';
import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import { mapGetters, mapMutations } from 'vuex';
import { formatDateId, formatDateLongStr, upLoadImg } from '@/utils/utils.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetIdCardFrontUrlV2, GetIdCardBackUrlV2, GetIdNameFaceServiceUrl, UpdateIdCardInfoFaceActive, YMTivingThing } from '@/api/weChat.js';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'IdCardInfo',
  components: { camera, camera2, SvgIcon, Liveness },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
        address: '',
        familyName: '',
        birthday: '',
        sex: '',
        office: '',
        dateOfIssue: '',
        dateOfInvalid: '',
        dateOf: '',
      },
      // 按钮当前的状态
      btnStatus: 1,
      // 是否需要活体认证
      faceDetectActivity: 0,
      // 是否需要手持
      userIsNeedHandIdentityCard: false,
      livingFacePopupVisible: false,
      token: '',
      mobile: '',
      product: '',
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    // 按钮状态名称
    btnName() {
      let name = '提交';
      switch (this.btnStatus) {
        case 1:
          name = '提交';
          break;
        default:
          name = '下一步';
      }
      return name;
    },
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.faceDetectActivity = this.$route.query.faceDetectActivity - 0;
      this.userIsNeedHandIdentityCard = this.$route.query.userIsNeedHandIdentityCard === 'true';
      this.token = this.$route.query.token;
      this.mobile = this.$route.query.mobile;
      this.product = this.$route.query.product;
      this.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 调用接口上传人脸照片
    updateIdCardInfoFaceActive(url, callback = null) {
      const batchNumber = Math.floor(Math.random() * 900000000 + 100000000);
      UpdateIdCardInfoFaceActive({ url, batchNumber })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            () => {
              callback && callback();
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 活体识别
    renLianInfo() {
      const discernFaceDate = sessionStorage.getItem('discernFaceDate') || 0;
      const mobile = this.$route.query.mobile || 99999999999;
      if (discernFaceDate - 0 !== formatDateId(new Date()) - 0) {
        sessionStorage.setItem('discernFaceDate', formatDateId(new Date()) - 0);
        sessionStorage.setItem(`${mobile}_facecount`, 0);
      }
      const faceCount = sessionStorage.getItem(`${mobile}_facecount`) || 0;
      const faceMaxCount = this.$route.query.facemax || 50;
      if (faceCount - 0 < faceMaxCount - 0) {
        if (faceMaxCount - 0 - (faceCount - 0) < 3) {
          // 请确定是否为身份证本人的人脸信息。
          CusAlert('您今天人脸识别次数还剩' + (faceMaxCount - 0 - (faceCount - 0)) + '次机会', () => {
            this.jumpToLiveness();
          });
        } else {
          this.jumpToLiveness();
        }
      } else {
        CusAlert('今天人脸识别次数已达上限，请明天再试');
      }
    },
    // 返回的图片信息
    getImgInfo(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        this.mobile,
        yes => {
          if (yes.code === 0) {
            // 银行卡识别的都是传url
            let reqUrl = null;
            let reqData = null;

            switch (info.type) {
              case 'renXiang':
                reqUrl = GetIdCardFrontUrlV2;
                reqData = {
                  url: yes.data,
                  batchNo: this.idCardBatchNo,
                };
                break;
              case 'guoHui':
                reqUrl = GetIdCardBackUrlV2;
                reqData = {
                  url: yes.data,
                  batchNo: this.idCardBatchNo,
                };
                break;
              case 'ymt':
                reqUrl = YMTivingThing;
                reqData = { url: yes.data };
                break;
              case 'renLian':
                this[info.type].webUrl = yes.data;
                reqData = { url: yes.data };
                break;
            }
            if (info.type === 'renLian') {
              return;
            }
            CusLoadingOpen('识别中...');
            reqUrl(reqData)
              .then(res => {
                CusLoadingClose();
                if (res.code === 0) {
                  this[info.type].webUrl = yes.data;
                  res.msg && CusAlert(res.msg);
                  switch (info.type) {
                    case 'renXiang':
                      this.formData.idCardName = res.data.Name;
                      this.formData.idCardNum = res.data.IdCardNum;
                      this.formData.address = res.data.Address;
                      this.formData.familyName = res.data.FamilyName;
                      this.formData.birthday = res.data.Birthday;
                      this.formData.sex = res.data.Sex;
                      break;
                    case 'guoHui':
                      this.formData.office = res.data.Office;
                      this.formData.dateOfIssue = res.data.DateOfIssue;
                      this.formData.dateOfInvalid = res.data.DateOfInvalid;
                      this.formData.dateOf = `${res.data.DateOfIssue} - ${res.data.DateOfInvalid}`;
                      break;
                    case 'ymt':
                      this.$nextTick(() => {
                        this.renLian.webUrl = yes.data;
                        this.renLian.fileUrl = yes.data;
                        this.renLian.base64 = yes.data;
                      });
                      break;
                  }
                } else {
                  CusAlert(res.msg, () => {
                    switch (info.type) {
                      case 'renXiang':
                      case 'guoHui':
                        this.resetCameraInfo(info.type);
                        break;
                      case 'ymt':
                        this.$nextTick(() => {
                          this.renLian.webUrl = yes.data;
                          this.renLian.fileUrl = yes.data;
                          this.renLian.base64 = yes.data;
                          this.btnStatus = 3;
                        });
                        break;
                    }
                  });
                }
              })
              .catch(() => {
                CusLoadingClose();
              });
          } else {
            switch (info.type) {
              case 'renXiang':
              case 'guoHui':
                this.resetCameraInfo(info.type);
                break;
              case 'ymt':
                this.$nextTick(() => {
                  this.renLian.webUrl = yes.data;
                  this.renLian.fileUrl = yes.data;
                  this.renLian.base64 = yes.data;
                  this.btnStatus = 3;
                });
                break;
            }
          }
        },
        () => {
          switch (info.type) {
            case 'renXiang':
            case 'guoHui':
              this.resetCameraInfo(info.type);
              break;
            case 'ymt':
              this.resetCameraInfo(info.type, 3);
              break;
          }
        }
      );
    },
    // 提交数据
    submitData() {
      switch (this.btnStatus) {
        case 1:
          this.btnStatus = 3;
          break;
        case 2:
          this.upLoadData();
          break;
        case 3:
          this.upLoadData();
          break;
      }
    },
    // 提交数据
    upLoadData() {
      var data = {};
      data.url = this.renLian.webUrl;
      data.batchNo = this.idCardBatchNo;
      CusLoadingOpen();
      GetIdNameFaceServiceUrl(data)
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              if (this.userIsNeedHandIdentityCard) {
                //  手持
                this.replacePage('HandIdCard', {
                  idCardName: this.formData.idCardName,
                  idCardNum: this.formData.idCardNum,
                  token: this.token,
                  product: this.product,
                });
              } else {
                // 不需要手持
                wx.miniProgram.redirectTo({
                  url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
                });
              }
            });
          } else {
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              this.btnStatus = 3;
              CusAlert(res.msg, () => {
                if (res.innerCode === 7776) {
                  this.replacePage('ManualAudit', {
                    idCardName: this.formData.idCardName,
                    idCardNum: this.formData.idCardNum,
                    token: this.token,
                    product: this.product,
                  });
                }
              });
            });
          }
        })
        .catch(err => {
          CusLoadingClose();
          CusAlert(err.msg);
        });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      name === 'renLian' && (this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS);
      this.btnStatus = staus;
    },
    // 跳人工审核
    jumpManualAudit() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
        CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
          CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
            this.replacePage('ManualAudit', {
              idCardName: this.formData.idCardName,
              idCardNum: this.formData.idCardNum,
              token: this.token,
              product: this.product,
            });
          });
        });
      });
    },
    // 跳人脸识别
    jumpToLiveness() {
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          this.$refs.camera.imgClick('renLian');
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          this.$refs.camera2.imgClick('ymt');
          break;
      }
    },
  },
};
</script>
